import { useCallback, useEffect, useRef, useState } from 'react';

// Each resource gets its own sequence so only its latest request can update UI.
export default function useLatestRequest() {
  const sequence = useRef(0);
  const [loading, setLoading] = useState(true);
  useEffect(() => () => { sequence.current += 1; }, []);

  const begin = useCallback(() => {
    const id = ++sequence.current;
    setLoading(true);
    return {
      isCurrent: () => id === sequence.current,
      finish: () => {
        if (id === sequence.current) setLoading(false);
      },
    };
  }, []);

  return { loading, begin };
}
